import { useEffect } from 'react'
import { ChromeIcon } from '@/components/ChromeIcon'
import { formatRelative } from '@/lib/utils'
import styles from './help.module.css'
import { WEB_ASSETS } from '@tenfour/contracts'

export interface SupportToastData {
  requestId: string
  preview: string
  at: string
}

const AUTO_DISMISS_MS = 15_000

/**
 * The support-reply follow-up card (reference: references/helpcenter/apps-web/
 * followup-inapp*.png): a floating white card above the bottom-right corner —
 * logo avatar, one-line preview, "Ten Four Support · Nm", hover ✕. Clicking it
 * opens the messenger on that thread. Sits above the drawer/messenger
 * (z-index 70 > 60) — the old Toast container's 50 rendered under them.
 */
export function SupportToast({
  toast,
  onOpen,
  onDismiss,
}: {
  toast: SupportToastData
  onOpen: (requestId: string) => void
  onDismiss: () => void
}) {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, AUTO_DISMISS_MS)
    return () => window.clearTimeout(timer)
  }, [toast.requestId, toast.at, onDismiss])

  return (
    <div className={styles.toast} role="status" aria-live="polite">
      <button
        type="button"
        className={styles.toastBody}
        onClick={() => onOpen(toast.requestId)}
        aria-label="Open support reply"
      >
        <span className={styles.brandAvatar} style={{ width: 38, height: 38 }} aria-hidden>
          <img src={WEB_ASSETS.brand.favicon} alt="" />
        </span>
        <span className={styles.toastText}>
          <span className={styles.toastPreview}>{toast.preview}</span>
          <span className={styles.toastMeta}>Ten Four Support · {formatRelative(toast.at)}</span>
        </span>
      </button>
      <button
        type="button"
        className={styles.toastDismiss}
        aria-label="Dismiss notification"
        onClick={onDismiss}
      >
        <ChromeIcon name="close" size={14} />
      </button>
    </div>
  )
}
